import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";

const GetInTouch = ({ heading, message, email }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const spring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0)" : "translateY(30px)",
    config: { tension: 180, friction: 30 },
  });

  return (
    <section id="contact" className="contact-section">
      <div className="stars-overlay" />
      <animated.div ref={ref} style={spring} className="contact-inner">
        <div className="contact-icon">✉</div>
        <h2 className="contact-heading">{heading}</h2>
        <p className="contact-message">{message}</p>
        <a href={`mailto:${email}`} className="contact-button">
          Say Hello
        </a>
      </animated.div>
    </section>
  );
};

export default GetInTouch;
